module.exports = __webpack_public_path__ + "static/img/about.703300e.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/zh/about.png
// module id = hMBo
// module chunks = 1